import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from './actions';

class EnableSwitch extends Component {
    onClick(use) {
        this.props.dispatch(Action.do('useProjectionBoostRule', !use));
    }

    render() {
        const {projectionBoostRule} = this.props;

        return (
            <div className="lineup-control">
                <div className="lineup-control-holder">
                    <div className="filter-btn-group">
                        <button
                            type="button"
                            className={!projectionBoostRule.isEnabled() ? 'active' : ''}
                            onClick={(() => this.onClick(projectionBoostRule.isEnabled())).bind(this)}
                        >
                            Off
                        </button>
                        <button
                            type="button"
                            className={projectionBoostRule.isEnabled() ? 'active' : ''}
                            onClick={(() => this.onClick(projectionBoostRule.isEnabled())).bind(this)}
                        >
                            On
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {projectionBoostRule} = state;

    return {
        projectionBoostRule,
    };
}

export default connect(mapStatesToProps)(EnableSwitch);
